<template>
  <div class="add-price-view">
    <!-- Top bar navigation -->
    <header class="app navigation" style="flex: 0; background-color: var(--msag-color); padding: 10px; position: sticky; top:0; z-index: 10;">
      <v-container>
        <v-row justify="space-between" style="align-items: center; padding-bottom: 5px;">
          <div style="margin-right:10px;">
            <v-row justify="space-between" style="align-items: center;">
              <v-col style="flex:0;">
                <div style="background-color:white; padding: 10px; border-radius: 10px; height: 50px; width: 50px;">
                  <img src="@/assets/Maklersprechstunde-Logo.png" alt="Square Image" style="width: 30px; height: 30px;"/>
                </div>
              </v-col>
              <v-col style="flex:1; padding: 0px; margin: 0px;">
                <h1 style="color: white; text-align: left;">Portalpreise.com</h1>
              </v-col>

              <router-link to="/">
                <a class="addButton" style="margin: 5px 10px;">
                  Zur Karte
                </a>
              </router-link>

              <router-link to="/list">
                <a class="addButton" style="margin: 5px 10px;">
                  Liste
                </a>
              </router-link>
            </v-row>
          </div>
        </v-row>
      </v-container>
    </header>

    <v-container style="max-width: 720px; padding-bottom: 40px;">
      <!-- Progress steps -->
      <v-card class="form-card" style="margin-top: 20px;">
        <FormSteps :current="1" />
      </v-card>

      <!-- Entry form -->
      <v-card class="form-card" style="margin-top: 20px;">
        <h2 class="title-text text-left">Neuen Eintrag erstellen</h2>
        <v-form ref="form" v-model="isFormValid" @submit.prevent="submit()">
          <h3 class="section-heading">Portalpreise Informationen (wird veröffentlicht)</h3>

          <label class="field-label">Portal <span class="required-star">*</span></label>
          <v-autocomplete
            v-model="form.portal"
            :items="portalItems"
            :rules="[required]"
            :filter="portalFilter"
            :menu-props="{ offsetY: true }"
            attach
            outlined
            dense
            hide-details="auto"
            placeholder="Portal suchen..."
            class="form-field"
          />

          <template v-if="form.portal === 'Anderes'">
            <label class="field-label">Welches Portal? <span class="required-star">*</span></label>
            <v-text-field
              v-model="form.portal_other"
              placeholder="Name des Portals"
              :rules="[required]"
              outlined
              dense
              hide-details="auto"
              class="form-field"
            />
          </template>

          <label class="field-label">Wie viele Objekte dürfen Sie maximal gleichzeitig online stellen? <span class="required-star">*</span></label>
          <p class="field-description">Bei unbegrenzt geben Sie 1000 an</p>
          <v-text-field
            v-model="form.objects_per_month"
            type="number"
            min="0"
            placeholder="1-1000"
            :rules="[required, positiveNumberRule]"
            outlined
            dense
            hide-details="auto"
            class="form-field"
          />

          <label class="field-label">Haben Sie Vertrags-Zusätze? (Top Platzierung, ...) <span class="required-star">*</span></label>
          <v-select
            v-model="form.contract_additions"
            :items="[{ text: 'Ja', value: true }, { text: 'Nein', value: false }]"
            :rules="[requiredBoolean]"
            :menu-props="{ offsetY: true }"
            attach
            outlined
            dense
            hide-details="auto"
            class="form-field"
          />

          <label class="field-label">Wie viel € bezahlen Sie pro Monat? <span class="required-star">*</span></label>
          <v-text-field
            v-model="form.price_per_month"
            type="number"
            min="0"
            placeholder="Preis in € (netto)"
            :rules="[required, positiveNumberRule]"
            outlined
            dense
            hide-details="auto"
            class="form-field"
          />

          <label class="field-label">Seit wann bezahlen Sie diesen Preis? <span class="required-star">*</span></label>
          <v-text-field
            v-model="form.price_date"
            type="date"
            :rules="[required]"
            outlined
            dense
            hide-details="auto"
            class="form-field"
          />

          <label class="field-label">Ihre Tätigkeit <span class="required-star">*</span></label>
          <p v-if="showProfessionError" class="profession-error">Bitte wählen Sie mindestens eine Tätigkeit aus</p>
          <v-row class="form-field" style="margin: 0px 0px 16px 0px;">
            <v-col
              v-for="item in professionItems"
              :key="item.value"
              cols="auto"
              style="padding: 0px 24px 0px 0px;"
            >
              <v-checkbox
                v-model="form.professions"
                :label="item.text"
                :value="item.value"
                hide-details
                style="margin-top: 0px;"
              />
            </v-col>
          </v-row>

          <label class="field-label">Ihre Postleitzahl <span class="required-star">*</span></label>
          <v-text-field
            v-model="form.zip"
            type="text"
            inputmode="numeric"
            placeholder="12345"
            :rules="[required, zipRule]"
            outlined
            dense
            hide-details="auto"
            class="form-field"
          />

          <label class="field-label">Ihr Land <span class="required-star">*</span></label>
          <v-select
            v-model="form.country"
            :items="countryItems"
            :rules="[required]"
            :menu-props="{ offsetY: true }"
            attach
            outlined
            dense
            hide-details="auto"
            class="form-field"
          />

          <h3 class="section-heading">Kontaktdaten (wird nicht veröffentlicht)</h3>

          <label class="field-label">Ihre E-Mail <span class="required-star">*</span></label>
          <v-text-field
            v-model="form.email"
            type="email"
            placeholder="E-Mail"
            :rules="[required, emailRule]"
            outlined
            dense
            hide-details="auto"
            class="form-field"
          />

          <label class="field-label">Ihr Firmenname <span class="required-star">*</span></label>
          <v-text-field
            v-model="form.company_name"
            placeholder="Max Makler Immobilien"
            :rules="[required]"
            outlined
            dense
            hide-details="auto"
            class="form-field"
          />

          <label class="field-label">Ihre Postadresse <span class="required-star">*</span></label>
          <v-text-field
            v-model="form.address"
            :rules="[required]"
            outlined
            dense
            hide-details="auto"
            class="form-field"
          />

          <label class="field-label">Ihre Firmen Webseite</label>
          <v-text-field
            v-model="form.company_url"
            placeholder="www.maklersprechstunde.com"
            outlined
            dense
            hide-details="auto"
            class="form-field"
          />

          <h3 class="section-heading">Bitte bestätigen Sie</h3>

          <label class="field-label">Datenschutz <span class="required-star">*</span></label>
          <v-checkbox
            v-model="form.datenschutz"
            :rules="[requiredCheckbox]"
            hide-details="auto"
            class="form-field"
            style="margin-top: 0px;"
          >
            <template v-slot:label>
              <span>
                Ich habe die
                <router-link to="/datenschutzerklaerung" target="_blank" @click.native.stop>Datenschutzerklärung</router-link>
                zur Kenntnis genommen.
              </span>
            </template>
          </v-checkbox>

          <label class="field-label">Werbeerlaubnis</label>
          <v-checkbox
            v-model="form.ad_consent"
            label="Ich bin damit einverstanden, dass mich die Makler Service AG, per Mail und/oder Telefon, zu Werbezwecken kontaktieren darf."
            hide-details
            class="form-field"
            style="margin-top: 0px;"
          />

          <v-btn
            class="submit-btn"
            large
            :loading="isSubmitting"
            @click="submit()"
          >
            Eintrag erstellen
          </v-btn>

          <p class="form-footnote">
            Ihre Kontaktdaten dienen der Authentifizierung. Ihre Angaben werden anonymisiert
            auf portalpreise.com veröffentlicht.
          </p>
        </v-form>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { postToServer } from "@/scripts/serverCalls";
import FormSteps from "@/components/FormSteps.vue";

export default {
  name: "AddPriceView",

  components: {
    FormSteps,
  },

  data: () => ({
    isFormValid: false,
    isSubmitting: false,
    showProfessionError: false,
    countryItems: ["Deutschland", "Österreich", "Schweiz", "Liechtenstein", "Luxemburg"],
    // Maps country names to the Area zipcode prefixes, used for query parameter prefill
    countryPrefixes: {
      DE: "Deutschland",
      AT: "Österreich",
      CH: "Schweiz",
      LI: "Liechtenstein",
      L: "Luxemburg",
    },
    portalItems: [
      { text: "Immoscout24", value: "Immoscout" },
      { text: "Immowelt", value: "Immowelt" },
      { text: "Immonet", value: "Immonet" },
      { text: "Kleinanzeigen Immobilien", value: "Kleinanzeigen" },
      { text: "Immobilie1", value: "Immobilie1" },
      { text: "Willhaben", value: "Willhaben" },
      { text: "properti", value: "properti" },
      { text: "Anderes", value: "Anderes" },
    ],
    // Displayed like the previous Wordpress form, stored values match the map filters
    professionItems: [
      { text: "Makler", value: "Immobilienmakler" },
      { text: "Bauträger", value: "Bauträger" },
      { text: "Verwalter", value: "Immobilienverwalter" },
    ],
    form: {
      portal: null,
      portal_other: "",
      objects_per_month: null,
      contract_additions: null,
      price_per_month: null,
      price_date: null,
      professions: [],
      zip: "",
      country: "Deutschland",
      email: "",
      company_name: "",
      address: "",
      company_url: "",
      datenschutz: false,
      ad_consent: false,
    },
    required: (v) => (v !== null && v !== undefined && v !== "") || "Pflichtfeld",
    requiredBoolean: (v) => typeof v === "boolean" || "Pflichtfeld",
    requiredCheckbox: (v) => v === true || "Pflichtfeld",
    zipRule: (v) => /^\d{4,5}$/.test(String(v ?? "").trim()) || "Ungültige Postleitzahl",
    emailRule: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v ?? "") || "Ungültige E-Mail-Adresse",
    positiveNumberRule: (v) => (!isNaN(parseInt(v, 10)) && parseInt(v, 10) >= 0) || "Ungültige Zahl",
  }),
  watch: {
    "form.professions"(value) {
      if (value.length > 0) this.showProfessionError = false;
    },
    // Keeps a draft of the form so no input is lost on reload or navigation
    form: {
      deep: true,
      handler(value) {
        try {
          sessionStorage.setItem("addPriceDraft", JSON.stringify(value));
        } catch (e) { /* Storage unavailable, drafts are just a convenience */ }
      },
    },
  },
  methods: {
    /**
     * Filters the portal dropdown by search input, "Anderes" always stays visible
     */
    portalFilter(item, queryText, itemText) {
      if (item.value === "Anderes") return true;
      return itemText.toLowerCase().includes(queryText.toLowerCase());
    },
    /**
     * Validates and submits the form to the server
     */
    async submit() {
      const formValid = this.$refs.form.validate();
      this.showProfessionError = this.form.professions.length === 0;
      if (!formValid || this.showProfessionError) {
        window.globalToast.error("Bitte füllen Sie alle mit * markierten Pflichtfelder aus");
        return;
      }
      this.isSubmitting = true;

      await postToServer(
        "map/prices/create",
        {
          portal: this.form.portal === "Anderes" ? this.form.portal_other.trim() : this.form.portal,
          objects_per_month: parseInt(this.form.objects_per_month, 10),
          contract_additions: this.form.contract_additions,
          price_per_month: parseInt(this.form.price_per_month, 10),
          price_date: this.form.price_date,
          profession: this.form.professions.join(", "),
          zip: String(this.form.zip).trim(),
          country: this.form.country,
          email: this.form.email,
          company_name: this.form.company_name,
          address: this.form.address,
          company_url: this.form.company_url || null,
          ad_consent: this.form.ad_consent,
        },
        (res) => {
          this.isSubmitting = false;
          if (res?.status === 201) {
            const email = this.form.email;
            try {
              sessionStorage.removeItem("addPriceDraft");
            } catch (e) { /* Storage unavailable */ }
            this.$router.push({ path: "/eintrag-erstellt", query: { email } });
          } else {
            const errors = res?.response?.data?.errors;
            window.globalToast.error(
              errors?.length ? errors.join(", ") : "Eintrag konnte nicht gespeichert werden"
            );
          }
        }
      );
    },
  },
  mounted() {
    // Restores a saved draft so no input is lost on reload or navigation
    try {
      const draft = sessionStorage.getItem("addPriceDraft");
      if (draft) Object.assign(this.form, JSON.parse(draft));
    } catch (e) { /* Storage unavailable or corrupt draft, starts empty */ }

    // Prefills country and zipcode from query parameter, e.g. ?plz=DE-12345
    const plz = this.$route.query.plz;
    if (plz) {
      const [prefix, zip] = String(plz).split("-");
      if (this.countryPrefixes[prefix]) this.form.country = this.countryPrefixes[prefix];
      if (zip) this.form.zip = zip;
    }
  },
};
</script>
<style lang="scss">
.add-price-view {
  min-height: 100vh;
  background-color: #f5f5f5;

  .form-card {
    border-radius: 16px !important;
    padding: calc(1rem + 0.5vw + 0.5vh);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08) !important;
  }

  .section-heading {
    text-align: left;
    color: var(--font-color);
    font-size: calc(0.75rem + 0.4vw + 0.2vh);
    margin: 24px 0px 12px 0px;
    padding-bottom: 6px;
    border-bottom: 1px solid #e0e0e0;
  }

  .field-label {
    display: block;
    text-align: left;
    color: var(--font-color);
    margin-bottom: 4px;
  }

  .required-star {
    color: #ff5252;
  }

  .field-description {
    text-align: left;
    color: var(--secondaryfont-color);
    margin: -2px 0px 4px 0px;
    font-size: calc(0.4rem + 0.85vmin);
  }

  .form-field {
    margin-bottom: 16px;
  }

  // Checkbox labels in regular font color instead of Vuetify's muted grey
  .v-input--checkbox .v-label {
    color: var(--font-color);
  }

  // Rounder corners for outlined inputs
  .v-text-field--outlined fieldset {
    border-radius: 10px;
    border-color: #d5d5d5;
  }
  .v-text-field--outlined.v-input--is-focused fieldset {
    border-color: var(--msag-color);
  }
  .v-input--is-focused .v-input__slot {
    background-color: #f7faff;
  }

  .submit-btn {
    border-radius: 10px;
    text-transform: none;
    font-weight: 600;
    letter-spacing: inherit;
    padding: 0px 30px !important;
    margin-top: 8px;
    background-color: var(--msag-color) !important;
    color: white !important;
  }
  .submit-btn.v-btn--disabled {
    background-color: #c9d4e4 !important;
    color: white !important;
  }

  .profession-error {
    text-align: left;
    color: #ff5252;
    margin: 0px 0px 4px 0px;
    font-size: calc(0.4rem + 0.85vmin);
  }

  .form-footnote {
    text-align: left;
    color: var(--secondaryfont-color);
    margin: 16px 0px 0px 0px;
    font-size: calc(0.4rem + 0.85vmin);
  }
}
</style>
